<template>
  <tr :class="odd ? 'odd' : 'even'">
    <td
      :id="`td-escutar-${id}`"
      class="tddmcvivo text-center max40px"
      style="cursor: pointer; padding-left: 5px; width: 40px; max-width: 40px; padding-right: 0;"
      @click="pausePlay"
    >
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            :id="`btn-escutar-${id}`"
            icon
            v-on="on"
          >
            <v-icon
              color="green darken-2"
              :id="`icon-escutar-${id}`"
            >
              mdi-play-circle-outline
            </v-icon>
          </v-btn>
        </template>
        <span>Reproduzir</span>
      </v-tooltip>
    </td>

    <td
      :id="`td-assunto-${id}`"
      class="max23vw"
    >
      <a
        :id="`dialog-detalhes-audio-${id}`"
        :href="'#'.concat(`${assunto}`.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/--/g, '-'))"
        @click="$emit('on-view', id)"
        style="text-decoration: none"
      >
        <span>{{ assunto }}</span>

        <br>
        <small :id="`small-duracao-${id}`">
          <i :id="`i-duracao-${id}`">{{ durationFormated }}</i>
        </small>&nbsp;-&nbsp;
        <small v-if="!orador || orador == dirigente"><b>{{ dirigente }}</b></small>
        <small v-if="orador && orador != dirigente"><b>{{ orador }}</b></small>
      </a>

      <div v-if="viewPhone">
        <div style="margin: 5px 0">
          <v-divider />
        </div>

        <a
          :id="`dialog-detalhes-sessao-${id}`"
          :href="'#'.concat(`${sessao} ${album || formatDate}`.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/--/g, '-'))"
          @click="onOpenList"
          style="text-decoration: none"
        >
          <small>
            {{ core }}
            <br>
            {{ formatDegreeDate }}
          </small>
        </a>

        <div style="margin: 5px 0">
          <v-divider />
        </div>

        <div style="margin: 0 0 9px">
          <AudioSearchRevisorBtn
            v-if="showRevisor"

            :id="id"
            :color="color"

            :user-name="revisao ? revisao.user.name : ''"
            :user-degree="revisao ? revisao.user.degree : ''"
            :user-review="Boolean(revisao ? revisao.user.id : false)"

            :review-user="revisorNome"
            :review-status="aprovado"
            :review-degree="revisorGrau"
          />
        </div>
      </div>
    </td>

    <td
      :id="`td-nucleo-${id}`"
      v-if="!viewPhone"
    >
      {{ core }}
      <br v-if="core && formatDate">
      <small v-if="formatDate">{{ formatDate }}</small>
    </td>

    <td
      :id="`td-sessao-${id}`"
      v-if="!viewPhone"
      class="max23vw"
    >
      <template v-for="album in listAlbums">
        <v-tooltip
          bottom
          :key="`btn-${album.id}`"
        >
          <template #activator="{ on }">
            <v-btn
              text
              small
              no-caps
              color="green"
              v-on="on"
              @click="(event) => openAlbum(event, album)"
            >
              {{ album.nome }}
            </v-btn>
          </template>
          <span>Clique aqui para ouvir o álbum inteiro</span>
        </v-tooltip>
        <br :key="`br-${album.id}`">
      </template>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            text
            small
            color="primary"
            v-on="on"
            @click="openSessao"
          >
            <span>{{ sessao }}</span>
          </v-btn>
        </template>
        <span>Clique aqui para ouvir a sessão inteira</span>
      </v-tooltip>
    </td>

    <td
      :id="`td-revisao-${id}`"
      v-if="isAdmin || (!viewPhone && showRevisor)"
      class="tddmcvivo text-center"
    >
      <v-tooltip
        bottom
        color="primary"
        v-if="isAdmin"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            x-small
            icon
            color="primary"
            :href="audioUrl"
            target="_blank"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>
              mdi-monitor-arrow-down-variant
            </v-icon>
          </v-btn>
        </template>
        <span>Fazer download do Áudio</span>
      </v-tooltip>

      <v-tooltip
        bottom
        color="primary"
        v-if="isAdmin"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            x-small
            icon
            color="primary"
            @click="handleCopy"
            v-bind="attrs"
            v-on="on"
            class="ml-1"
          >
            <v-icon>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>
        <span>Copiar link do Áudio</span>
      </v-tooltip>

      <AudioSearchRevisorBtn
        :id="id"
        :color="color"

        v-if="viewPhone && showRevisor"

        :user-name="revisao ? revisao.user.name : ''"
        :user-degree="revisao ? revisao.user.degree : ''"
        :user-review="Boolean(revisao ? revisao.id : false)"

        :review-user="revisorNome"
        :review-status="aprovado"
        :review-degree="revisorGrau"
      />
    </td>
  </tr>
</template>

<script>
import { formatSecs, getToken, getSession } from '@/utils'
import { getHostAPI, requests } from '@/plugins/Amplify'
import AudioSearchRevisorBtn from './AudioSearchRevisorBtn'
import copy from 'copy-to-clipboard'
import PageBus from '@/components/page/PageBus'

export default {
  components: {
    AudioSearchRevisorBtn
  },

  props: {
    id: {},

    odd: {},
    color: {},
    showRevisor: {},

    albums: {},
    aprovado: {},
    assunto: {},
    data: {},
    dirigente: {},
    duracao: {},
    grau: {},
    nucleo: {},
    nucleoId: {},
    orador: {},
    revisao: {},
    revisorGrau: {},
    revisorNome: {},
    sessao: {},
    sessaoId: {}
  },

  data () {
    return {
      token: null,
      isAdmin: false
    }
  },

  computed: {
    audioUrl () {
      const vm = this
      return vm.isAdmin ? `${getHostAPI()}/audios/download?id=${vm.id}&token=${vm.token}` : null
    },

    viewPhone () {
      return this.$vuetify.breakpoint.xs
    },

    core () {
      const core = String(this.nucleo || '').trim().toLowerCase().split(' ').map((word) => {
        if (['da', 'de', 'do', 'a', 'e', 'i', 'o', 'u'].includes(word)) return word
        return word.charAt(0).toUpperCase() + word.slice(1)
      }).join(' ')

      if (core === 'Sede Geral') return core
      if (core.indexOf('Dav') === 0) return core.replace('Dav ', 'DAV ')
      return `Núcleo ${core}`
    },

    formatDate () {
      return this.data
        ? this.data.split('-').reverse().join('/')
        : 'Sem Data'
    },

    formatDegreeDate () {
      if (!this.data) return this.sessao
      const year = this.data.split('-')[0]
      const anual = [22, 23, 24, 25, 26, 27, 28, 30, 31].includes(this.sessaoId)
      if (anual) return `${this.sessao} | ${year}`
      return `${this.sessao} ${this.data.split('-').reverse().join('/')}`
    },

    durationFormated () {
      return formatSecs(this.duracao)
    },

    listAlbums () {
      const vm = this
      return Array.isArray(vm.albums) ? vm.albums : []
    }
  },

  mounted () {
    const vm = this

    getToken().then((token) => (
      getSession().then((session) => {
        const isAdmin = Boolean(session?.administrador)
        Object.assign(vm, { isAdmin, token })
      })
    ))
  },

  methods: {
    async openAlbum (event, album) {
      event.preventDefault()

      const data = await requests.getAudios({ limit: 999, album: album.id }).catch(() => null)
      if (!data?.rows?.length) return

      PageBus.$emit('playlist', data.rows.map((audio) => ({
        id: audio.id,
        data: audio.data,
        album: audio.albums.find(({ id }) => id === album.Id)?.nome,
        duracao: audio.duracao,
        assunto: audio.assunto,

        grau: audio.grauSigla,
        autor: audio.autorNome,
        nucleo: audio.nucleoNome,
        orador: audio.oradorNome,
        sessao: audio.sessaoDescricao,
        dirigente: audio.dirigenteNome
      })))
    },

    async openSessao (event) {
      event.preventDefault()

      const vm = this
      const params = { data: vm.data, limit: 999 }

      if (vm.nucleoId) {
        params.nucleo = vm.nucleoId
      } else {
        params.sessao = vm.sessaoId
      }

      const data = await requests.getAudios(params)
      if (!data?.rows?.length) return

      PageBus.$emit('playlist', data.rows.map((audio) => ({
        id: audio.id,
        data: audio.data,
        album: audio.albums.at(0)?.nome,
        duracao: audio.duracao,
        assunto: audio.assunto,

        grau: audio.grauSigla,
        autor: audio.autorNome,
        nucleo: audio.nucleoNome,
        orador: audio.oradorNome,
        sessao: audio.sessaoDescricao,
        dirigente: audio.dirigenteNome
      })))
    },

    pausePlay () {
      const vm = this

      PageBus.$emit('audioPlay', {
        id: vm.id,
        data: vm.data,
        album: vm.albums.at(0)?.nome ?? '',
        grau: vm.grau,
        nucleo: vm.nucleo,
        orador: vm.orador,
        sessaoId: vm.sessaoId,
        sessao: vm.sessao,
        duracao: vm.duracao,
        assunto: vm.assunto,
        dirigente: vm.dirigente
      })
    },

    onOpenList (e) {
      e.preventDefault()
    },

    handleCopy () {
      const vm = this
      if (vm.isAdmin) copy(vm.audioUrl)
    }
  }
}
</script>

<style scoped>
  tr.odd>td {
    background-color: #0094d90f
  }
</style>
